import { css } from '@emotion/css';

export const brandedBackground = (brandThemeColor?: string) =>
  brandThemeColor
    ? css`
        background-color: ${brandThemeColor};
      `
    : '';

export const hoverBackground = (brandThemeColor?: string) => css`
  &:hover {
    background-color: ${brandThemeColor ? 'rgba(255,255,255,0.2)' : 'var(--bg-hover)'};
  }
`;

export const translucentBg = css`
  background-color: rgba(255, 255, 255, 0.2);
`;

export const widgetBackgroundGradient = (gradientColor?: string | null, isMobile?: boolean) => {
  if (!gradientColor) {
    return '';
  }

  return css`
    border-radius: ${isMobile ? '0px' : '24px'};
    background: linear-gradient(90deg, ${gradientColor} 0%, #fff 100%),
      linear-gradient(336deg, #fef2f2 0.02%, #fff 100%);
  `;
};
